<template>
  <div>
    <div :class="showTop ? 'back-top on' : 'back-top'"
         @click="backTop">
      <img src="../../assets/img/top.jpg"
           alt="">
    </div>
  </div>
</template>

<script>
export default {
  name: 'Backtop',
  data () {
    return {
      showTop: false
    }
  },
  methods: {
    backTop () {
      var timer = null
      cancelAnimationFrame(timer)
      timer = requestAnimationFrame(function fn () {
        var oTop = document.body.scrollTop || document.documentElement.scrollTop

        if (oTop > 0) {
          scrollBy(0, -150)

          timer = requestAnimationFrame(fn)
        } else {
          cancelAnimationFrame(timer)
        }
      })
    }
  },
  mounted () {
    const _this = this
    document.body.onscroll = function () {
      const scrollTop = document.documentElement.scrollTop || document.body.scrollTop
      if (scrollTop > 300) {
        _this.showTop = true
      } else {
        _this.showTop = false
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  .back-top{
    opacity: 0;
    height: 0;
    transition: all .3s;
    img{
      position: fixed;
      right: 80px;
      bottom: 100px;
      width: 70px;
      height: 70px;
      border-radius: 100%;
      cursor: pointer;
    }
    &.on{
      // height: 70px;
      opacity: .5;
      &:hover{
        opacity: 1;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/view/LayOut/Backtop.vue